
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationService } from '../../application/application.service';
import { BackendService } from '../../backend.service';
import { CreateRazorpayOrderRequest, CreateRazorpayOrderResponse, DigioParameters, EnachSubmitRequest, MandateTypes, RazorpaySubmitRequest, CreateBillDeskOrderRequest, CreateValidatedVPARequest, CreateUpiMandateActivateRequest, CreateMandateSubscriptionStatusRequest } from './contracts/nach';
import { environment } from '../../../environments/environment';

@Injectable()
export class NachService {

  private downloadUnsignedNachUrl = '/documents/api/v1/customers/{customerId}/download/unsignedNach?applicationId={applicationId}';
  private checkAvailableMandateTypesUrl = '/mandates/customer/{customerId}/mandateTypes?applicationId={applicationId}&merchantId={merchantId}';
  private enachSubmitStatusUrl = '/enach/api/v1/mandateResponse/mandate/{mandateId}';
  private razorpaySubmitStatusUrl = '/razorpay_mandates/api/v1/payment_details/{customerId}?applicationId={applicationId}';
  private getDigioParametersUrl = '/enach/api/v1/transactions/{requestId}';
  private createRazorpayOrderUrl = '/razorpay_mandates/api/v1/order/{customerId}/{mandateOwnerId}';
  private createNetBankingDDOrderUrl = '/billdesk-netbanking-mandates/customer-details';
  private getMandateStatusDigioUrl = '/v3/client/mandate/{mandate_id}';
  private getOrderStatusBillDeskTransactionUrl = '/billdesk-netbanking-mandates/registration-status?orderId={orderId}';
  private downloadUnsignedDigioNachUrl = '/digio-nach/api/v1/customers/{customerId}/generateNach?applicationId={applicationId}';
  private getMandateTypesForPartnerRedirectUrl = '/mandates/customers/{customerId}/mode/{type}';
  private validateVpaURL = '/upi-autopay/api/v2/verify-vpa';
  private upiMandateActivateURL = '/upi-autopay/api/v2/mandate/activate';
  private getSubscriptionStatusURL = '/upi-autopay/api/v2/mandate/{subscriptionId}/status';
  constructor(private applicationService: ApplicationService, private backendService: BackendService) { }

  getUnsignedNachBase64String(): Observable<string> {
    const applicationId = this.applicationService.getApplicationId() ? this.applicationService.getApplicationId() : '';
    return this.backendService.getData(this.downloadUnsignedNachUrl.replace('{applicationId}', applicationId), 'text');
  }
  getUnsignedDigioNachBase64String(): Observable<string> {
    const applicationId = this.applicationService.getApplicationId();
    return this.backendService.setData(this.downloadUnsignedDigioNachUrl.replace('{applicationId}', applicationId ? applicationId : ''), '', 'text');
  }
  // purpose of merchantId query param is to identify that the call is through my_accounts. It need not be passed in other cases.
  checkAvailableMandateTypes(channel: string, merchantId?: string): Observable<MandateTypes> {
    this.checkAvailableMandateTypesUrl = merchantId ? this.checkAvailableMandateTypesUrl.replace('{merchantId}', merchantId) :
      this.checkAvailableMandateTypesUrl.replace('&merchantId={merchantId}', '');
    let url = this.checkAvailableMandateTypesUrl;
    const channelData = {
      channel: channel,
    };
    const applicationId = this.applicationService.getApplicationId() ? this.applicationService.getApplicationId() : '';
    url = url.replace('{applicationId}', applicationId);
    return this.backendService.setData(url, channelData);
  }
  submitEnachResponse(enachStatus: EnachSubmitRequest) {
    return this.backendService.setData(this.enachSubmitStatusUrl.replace('{mandateId}', enachStatus.documentId), enachStatus);
  }
  submitRazorpayResponse(razorpayStatus: RazorpaySubmitRequest) {
    let url = this.razorpaySubmitStatusUrl;
    const applicationId = this.applicationService.getApplicationId() ? this.applicationService.getApplicationId() : '';
    url = url.replace('{applicationId}', applicationId);
    return this.backendService.setData(url, razorpayStatus);
  }
  getDigioParameters(requestId: string): Observable<DigioParameters> {
    return this.backendService.getData(this.getDigioParametersUrl.replace('{requestId}', requestId));
  }
  createRazorpayOrder(mandateOwnerId: string, createRazorpayOrderRequest: CreateRazorpayOrderRequest): Observable<CreateRazorpayOrderResponse> {
    this.createRazorpayOrderUrl = mandateOwnerId ? this.createRazorpayOrderUrl.replace('{mandateOwnerId}', mandateOwnerId) :
    this.createRazorpayOrderUrl.replace('{mandateOwnerId}', '');
    return this.backendService.setData(this.createRazorpayOrderUrl, createRazorpayOrderRequest);
  }
  createBillDeskOrder(createBillDeskOrderRequest: CreateBillDeskOrderRequest): Observable<any> {
    return this.backendService.setData(this.createNetBankingDDOrderUrl, createBillDeskOrderRequest, 'text');
  }
  getMandateStatusFromDigio(mandateId: string): Observable<any> {
    const digio_client_secret = environment.production ? '2YSPTU47G1V31I9B8ETJUXKLXBBMJEWO' : '27XUIEB1MYH1LUZ7XJ5PKRXI8QC8O7I1';
    const authToken = 'Basic ' + btoa(environment.digio_client_id + ':' + digio_client_secret);
    const url = environment.digioUrl + this.getMandateStatusDigioUrl.replace('{mandate_id}', mandateId);
    return this.backendService.getCallForThirdPartyService(url, authToken);
  }
  getOrderStatusForBillDeskTransaction(orderId: string): Observable<string> {
    return this.backendService.getData(this.getOrderStatusBillDeskTransactionUrl.replace('{orderId}', orderId), 'text');
  }
  checkMandateTypesForPartnerRedirect(channel: string, type: string): Observable<MandateTypes> {
    let url = this.getMandateTypesForPartnerRedirectUrl;
    const channelData = {
      channel: channel,
    };
    url = url.replace('{type}', type);
    return this.backendService.setData(url, channelData);
  }
  createValidatedVPARequest(ValidatedVPARequest: CreateValidatedVPARequest): Observable<any> {
    const url = this.validateVpaURL;
    return this.backendService.setData(url, ValidatedVPARequest, 'text');
  }
  createUpiMandateActivateRequest(UpiMandateActivateRequest: CreateUpiMandateActivateRequest): Observable<any> {
    const url = this.upiMandateActivateURL;
    return this.backendService.setData(url, UpiMandateActivateRequest, 'text');
  }
  createMandateSubscriptionStatusRequest(SubscriptionStatusRequest: CreateMandateSubscriptionStatusRequest): Observable<any> {
    const subscriptionId = sessionStorage.getItem('subscriptionId');
    const url = this.getSubscriptionStatusURL.replace('{subscriptionId}', subscriptionId);
    return this.backendService.setData(url, SubscriptionStatusRequest, 'text');
  }
}
